import { Component, OnInit } from "@angular/core"
@Component({
  standalone: false,
  selector: "app-landing",
  templateUrl: "./landing.component.html",
})
export class LandingComponent implements OnInit {
  constructor() {}
  ngOnInit() {}
}
